import { OrdersByDay } from '@/hooks/useOrderStats';
import { CircularProgress, Paper, Stack, Typography } from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { red, green } from "@mui/material/colors";

interface Props {
    isLoading: boolean;
    data: OrdersByDay;
}

const OrdersPerWeek = ({ isLoading, data }: Props) => {
    if (isLoading) {
        return (
            <Stack flex={1} padding={4} alignItems="center" justifyContent="center">
                <CircularProgress />
            </Stack>
        )
    }

    if (!data?.length) {
        return null;
    }

    return (
        <Paper sx={{ p: 2 }}>
            <Stack spacing={2}>
                <Typography variant="overline" color="textSecondary">Pedidos por día</Typography>
                <ResponsiveContainer width="100%" height={250}>
                    <BarChart
                        width={500}
                        height={300}
                        data={data}
                        style={{ fontFamily: "'Fira Sans', sans-serif" }}
                    >
                        <XAxis
                            dataKey="id"
                            tickFormatter={(id) => data.find(d => d.id === id)?.day || id}
                        />
                        <YAxis style={{ fontFamily: "'Fira Sans', sans-serif" }} />
                        <Tooltip
                            labelFormatter={(label) => data.find(d => d.id === label)?.day || label}
                        />
                        <Bar
                            dataKey="completedOrders"
                            name="Completados"
                            stackId="a"
                            fill={green[500]}
                        />
                        <Bar
                            dataKey="rejectedOrders"
                            name="Rechazados"
                            stackId="a"
                            fill={red[500]}
                        />
                    </BarChart>
                </ResponsiveContainer>
            </Stack>
        </Paper>
    )
}

export default OrdersPerWeek;
